import apiCore from '../../utils/api-core';

export function getProducts() {
	return apiCore.get('/api/v1/store/products');
}

export function genStripeCheckoutSession(data){
	return apiCore.post('/api/v1/store/checkout',data);
}


